import { useQuery } from 'react-query';
import { modulesAPI } from '../services/api';

/**
 * Чи увімкнено модуль для поточного магазину (перемикає суперадмін).
 * Поки список не завантажився — false: розділ з'являється, лише коли
 * бекенд підтвердив, що модуль увімкнено.
 */
export const useModuleEnabled = (key: string): boolean => {
  const { data } = useQuery('admin-modules', modulesAPI.getAll, { staleTime: 5 * 60 * 1000, retry: 1 });
  return data?.some((m) => m.key === key && m.enabled) ?? false;
};
